import styled from '@emotion/styled';
import { Close } from '@mui/icons-material';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const StyledOverlay = styled('div')({
	position: 'absolute',
	top: 0,
	right: 0,
	bottom: 0,
	left: 0,
	// backgroundColor: 'rgba(0, 0, 0, .25)',
	backgroundColor: 'rgba(255, 255, 255, .5)',
	backdropFilter: 'blur(1px)',
	borderRadius: 3,
	zIndex: 10000,
	display: 'grid',
	justifyContent: 'center',
	alignContent: 'center'
});
const sxCloseButton = {
	position: 'absolute',
	top: '1rem',
	right: '1rem'
};
const sxBackdrop = {
	backgroundColor: 'rgba(0, 0, 0, .75)',
	//backdropFilter: 'blur(25px)',
	transitionProperty: 'all'
};

function CustomModal({
						 title,
						 isProcessing = false,
						 onClose,
						 children,
						 actions,
						 closeOnBackdropClick = false,
						 ...other
					 }) {
	const sxDialogContent = { maxHeight: '80vh' };
	if (actions) {
		sxDialogContent.paddingBottom = 0;
	}

	return (
		<Dialog
			{...{ maxWidth: 'xs', fullWidth: true, ...other }}
			onClose={(event, reason) => {
				if (!closeOnBackdropClick && reason === 'backdropClick') {
					return;
				}

				onClose(event, reason);
			}}
			slotProps={{
				backdrop: {
					sx: sxBackdrop,
				},
			}}
		>
			{title && <DialogTitle sx={{ paddingRight: '5.5rem' }}>{title}</DialogTitle>}
			<DialogContent sx={sxDialogContent}>
				<IconButton sx={sxCloseButton} onClick={onClose}><Close /></IconButton>
				{isProcessing && (<StyledOverlay><CircularProgress /></StyledOverlay>)}
				{children}
			</DialogContent>
			{actions && <DialogActions>{actions}</DialogActions>}
		</Dialog>
	);
}

CustomModal.propTypes = {
	open: PropTypes.bool.isRequired,
	isProcessing: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	maxWidth: PropTypes.string,
	title: PropTypes.string,
	actions: PropTypes.element,
	closeOnBackdropClick: PropTypes.bool,
}

export default CustomModal;
